import { render, staticRenderFns } from "./LockedFeatureDialog.vue?vue&type=template&id=0aa7c5d2&scoped=true&"
import script from "./LockedFeatureDialog.vue?vue&type=script&lang=ts&"
export * from "./LockedFeatureDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LockedFeatureDialog.vue?vue&type=style&index=0&id=0aa7c5d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa7c5d2",
  null
  
)

export default component.exports